export default "__VITE_ASSET__MEdlqM94__"